import type { BookingKind, TreatmentDuration } from "../types";

export type TreatmentProduct = {
  kind: BookingKind;
  duration: TreatmentDuration;
  /** Total price for one product, including both guests/therapists where applicable. */
  price: number;
  paymentUrl: string;
  sku: string;
};

// Public GotPose catalog checked on 2026-09-13. No quantity multiplier at checkout.
export const TREATMENT_PRODUCTS: readonly TreatmentProduct[] = [
  {
    "kind": "single",
    "duration": 45,
    "price": 300,
    "paymentUrl": "https://restore1.gotpose.com/shop/000056/%D7%A2%D7%99%D7%A1%D7%95%D7%9945%D7%93%D7%A7%D7%95%D7%AA%E2%80%93%D7%AA%D7%A9%D7%9C%D7%95%D7%9D%D7%90%D7%95%D7%A0%D7%9C%D7%99%D7%99%D7%9F",
    "sku": "000056"
  },
  {
    "kind": "single",
    "duration": 60,
    "price": 400,
    "paymentUrl": "https://restore1.gotpose.com/shop/00003%20Copy/%D7%A2%D7%99%D7%A1%D7%95%D7%9960%D7%93%D7%A7%D7%95%D7%AA%E2%80%93%D7%AA%D7%A9%D7%9C%D7%95%D7%9D%D7%90%D7%95%D7%A0%D7%9C%D7%99%D7%99%D7%9F",
    "sku": "00003 Copy"
  },
  {
    "kind": "single",
    "duration": 90,
    "price": 600,
    "paymentUrl": "https://restore1.gotpose.com/shop/00002443/%D7%A2%D7%99%D7%A1%D7%95%D7%9990%D7%93%D7%A7%D7%95%D7%AA%E2%80%93%D7%AA%D7%A9%D7%9C%D7%95%D7%9D%D7%90%D7%95%D7%A0%D7%9C%D7%99%D7%99%D7%9F",
    "sku": "00002443"
  },
  {
    "kind": "single",
    "duration": 120,
    "price": 750,
    "paymentUrl": "https://restore1.gotpose.com/shop/0000154/%D7%A2%D7%99%D7%A1%D7%95%D7%99120%D7%93%D7%A7%D7%95%D7%AA%E2%80%93%D7%AA%D7%A9%D7%9C%D7%95%D7%9D%D7%90%D7%95%D7%A0%D7%9C%D7%99%D7%99%D7%9F",
    "sku": "0000154"
  },
  {
    "kind": "couple",
    "duration": 45,
    "price": 600.0,
    "paymentUrl": "https://restore1.gotpose.com/shop/000053/%D7%A2%D7%99%D7%A1%D7%95%D7%99%D7%96%D7%95%D7%92%D7%9945%D7%93%D7%A7%D7%95%D7%AA%E2%80%94%D7%AA%D7%A9%D7%9C%D7%95%D7%9D%D7%90%D7%95%D7%A0%D7%9C%D7%99%D7%99%D7%9F",
    "sku": "000053"
  },
  {
    "kind": "couple",
    "duration": 60,
    "price": 800.0,
    "paymentUrl": "https://restore1.gotpose.com/shop/000034/%D7%A2%D7%99%D7%A1%D7%95%D7%99%D7%96%D7%95%D7%92%D7%9960%D7%93%D7%A7%D7%95%D7%AA%E2%80%94%D7%AA%D7%A9%D7%9C%D7%95%D7%9D%D7%90%D7%95%D7%A0%D7%9C%D7%99%D7%99%D7%9F",
    "sku": "000034"
  },
  {
    "kind": "couple",
    "duration": 90,
    "price": 1200.0,
    "paymentUrl": "https://restore1.gotpose.com/shop/0000246/%D7%A2%D7%99%D7%A1%D7%95%D7%99%D7%96%D7%95%D7%92%D7%9990%D7%93%D7%A7%D7%95%D7%AA%E2%80%94%D7%AA%D7%A9%D7%9C%D7%95%D7%9D%D7%90%D7%95%D7%A0%D7%9C%D7%99%D7%99%D7%9F",
    "sku": "0000246"
  },
  {
    "kind": "couple",
    "duration": 120,
    "price": 1500.0,
    "paymentUrl": "https://restore1.gotpose.com/shop/0000242/%D7%A2%D7%99%D7%A1%D7%95%D7%99%D7%96%D7%95%D7%92%D7%99120%D7%93%D7%A7%D7%95%D7%AA%E2%80%94%D7%AA%D7%A9%D7%9C%D7%95%D7%9D%D7%90%D7%95%D7%A0%D7%9C%D7%99%D7%99%D7%9F",
    "sku": "0000242"
  },
  {
    "kind": "fourHands",
    "duration": 45,
    "price": 600.0,
    "paymentUrl": "https://restore1.gotpose.com/shop/0000537/%D7%A2%D7%99%D7%A1%D7%95%D7%994%D7%99%D7%93%D7%99%D7%99%D7%9D%E2%80%9345%D7%93%D7%A7%D7%95%D7%AA%E2%80%93%D7%AA%D7%A9%D7%9C%D7%95%D7%9D%D7%91%D7%90%D7%AA%D7%A8",
    "sku": "0000537"
  },
  {
    "kind": "fourHands",
    "duration": 60,
    "price": 800.0,
    "paymentUrl": "https://restore1.gotpose.com/shop/0000347/%D7%A2%D7%99%D7%A1%D7%95%D7%994%D7%99%D7%93%D7%99%D7%99%D7%9D%E2%80%9360%D7%93%D7%A7%D7%95%D7%AA%E2%80%93%D7%AA%D7%A9%D7%9C%D7%95%D7%9D%D7%91%D7%90%D7%AA%D7%A8",
    "sku": "0000347"
  },
  {
    "kind": "fourHands",
    "duration": 90,
    "price": 1200.0,
    "paymentUrl": "https://restore1.gotpose.com/shop/0000249/%D7%A2%D7%99%D7%A1%D7%95%D7%994%D7%99%D7%93%D7%99%D7%99%D7%9D%E2%80%9390%D7%93%D7%A7%D7%95%D7%AA%E2%80%93%D7%AA%D7%A9%D7%9C%D7%95%D7%9D%D7%91%D7%90%D7%AA%D7%A8",
    "sku": "0000249"
  },
  {
    "kind": "fourHands",
    "duration": 120,
    "price": 1500.0,
    "paymentUrl": "https://restore1.gotpose.com/shop/00002429/%D7%A2%D7%99%D7%A1%D7%95%D7%994%D7%99%D7%93%D7%99%D7%99%D7%9D%E2%80%93120%D7%93%D7%A7%D7%95%D7%AA%E2%80%93%D7%AA%D7%A9%D7%9C%D7%95%D7%9D%D7%91%D7%90%D7%AA%D7%A8",
    "sku": "00002429"
  }
];

export const MASSAGE_RESOURCES = {
  single: { rooms: 1, therapists: 1 },
  couple: { rooms: 2, therapists: 2 },
  fourHands: { rooms: 1, therapists: 2 },
} as const;

export function getTreatments(kind: BookingKind | null): readonly TreatmentProduct[] {
  return TREATMENT_PRODUCTS.filter((product) => product.kind === kind);
}

export function getTreatment(kind: BookingKind | null, duration: TreatmentDuration | null) {
  return TREATMENT_PRODUCTS.find((product) => product.kind === kind && product.duration === duration) ?? null;
}
